import React from 'react';
import { Container, Typography, Grid } from '@mui/material';
import DeploymentDashboard from './DeploymentDashboard';
import EnvironmentSettings from './EnvironmentSettings';
import VersionControlPanel from './VersionControlPanel';
import AccessControls from './AccessControls';

const DeploymentManagement = () => {
  return (
    <Container maxWidth="xl">
      <Typography variant="h4" gutterBottom>Deployment Management</Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <DeploymentDashboard />
        </Grid>
        <Grid item xs={12} md={6}>
          <EnvironmentSettings />
        </Grid>
        <Grid item xs={12} md={6}>
          <VersionControlPanel />
        </Grid>
        <Grid item xs={12}>
          <AccessControls />
        </Grid>
      </Grid>
    </Container>
  );
};

export default DeploymentManagement;
